import { IconPlus, IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';

const AddIssue = ({ callback }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const submit = async () => {
        if (document.getElementById("issue").value) {
            let postData = {
                "issue": document.getElementById("issue").value
            }
            let resp = await postApi(postData, urlApi.addIssue);
            if (resp.responseCode === 200) {
                toast.success(resp.message);
                if (callback) {
                    callback();
                }
                handleClose();
            } else {
                toast.error(resp.message);
            }
        } else {
            toast.error("Please enter Issue");
        }
    }

    return (
        <>
            <button className='bg-teal-700 !px-5 !py-1.5 rounded-full text-sm text-white flex items-center !gap-1' onClick={handleShow}> <IconPlus size={16} /> Issue </button>
            <Modal show={show} onHide={handleClose} >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold"> Add A New Issue Topic</p>
                        <IconX className='cursor-pointer' color='white' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className="flex flex-col gap-1">
                        <label htmlFor="issue" className='font-medium'>Issue</label>
                        <input type="text" id='issue' placeholder="Issue" className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' />
                    </div>
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='px-4 py-1 bg-[var(--secondary)] text-white text-sm font-semibold rounded-lg' onClick={handleClose}>Cancel</button>
                        <button className='px-4 py-1 bg-[var(--secondary-gradient-1)] text-white text-sm font-semibold rounded-lg' onClick={() => submit()}>Submit</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddIssue